import { domain } from "utils/opscues";
import HTTPError from "errors/HTTPError";

export default function createRbfClient(auth) {
  const baseRbfUrl = domain({
    app: "rbf",
    /* global APPCUES_ENV */
    env: APPCUES_ENV,
    facet: "main"
  });

  return {
    recalculateSegmentMemberships: () =>
      Promise.all([auth.getToken(), auth.getAccountId()]).then(
        ([jwt, account_id]) =>
          fetch(
            `https://${baseRbfUrl}/v1/segment-membership-updater-account/jobs`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${jwt}`,
                "Content-Type": "application/json"
              },
              body: JSON.stringify({ account_id })
            }
          ).then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new HTTPError(response);
          })
      )
  };
}
